import { FC } from 'react';

export const NavigationBannerSlot: FC = () => {
    return <div id="navigation-banner-slot" />;
};
